<div class="relative">
    <button 
        type="button" 
        class="btn flex flex-row bg-white rounded-lg px-4 py-3 justify-between gap-4 w-full" 
        (click)="toggleDropdown()" 
        id="allergendropdown"
        [disabled]="_disabled"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin">
        <div class="w-11/12 text-ellipsis overflow-hidden text-start">
        @if (selectedAllergens.length === 0) {
        <span>{{'allergen.allergens' | translate}}</span>
        }@else {
            <span class="text-nowrap">
            @for (allergen of selectedAllergens; track allergen; let i = $index) {
                {{'allergen.' + allergen |translate}}@if(i < selectedAllergens.length-1){,}
            }
            </span>
        }
        </div>
        @if (!shown) {
        <i class="bi bi-chevron-down"></i>
        }@else {
        <i class="bi bi-chevron-up"></i>
        }
    </button>

    <ng-template 
        cdkConnectedOverlay 
        [cdkConnectedOverlayOrigin]="trigger" 
        [cdkConnectedOverlayOpen]="shown"
        [cdkConnectedOverlayWidth]="'origin'"
        [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
        (overlayOutsideClick)="closeDropdown()">
        <div class="bg-white rounded-lg shadow-lg border-none overflow-hidden text-e-dark-green mt-1 z-50">
            <div class="flex flex-col max-h-60 overflow-y-scroll p-1">
                @for (allergen of allergens; track allergen) {
                <div class="flex flex-row gap-2 p-2 rounded-lg hover:bg-e-reg-green cursor-pointer" (click)="toggleAllergen(allergen)">
                    @if (selectedAllergens.includes(allergen)) {
                    <i class="bi bi-check-square w-5"></i>
                    }@else {
                    <i class="bi bi-square w-5"></i>
                    }
                    <span>{{'allergen.' + allergen |translate}}</span>
                </div>
                }
            </div>
        </div>
    </ng-template>
</div>